import * as React from "react";
import { AuditList } from "../common/AuditList";

const BannerAudit = () => <AuditList resource="banners" />;

export default BannerAudit;
